<template>
  <div class="login-box">
    <div v-show="!resetPw">
      <div class="tab-wrap" v-if="loginType!=3">
        <span class="tab-title" :class="{active: this.activeTab==1}" @click="changeTab(1)">扫码登录</span>
        <span class="tab-title" :class="{active: this.activeTab==2}" @click="changeTab(2)">账号登录</span>
      </div>
      <div class="tab-wrap" style="padding-bottom: 11px;" v-else>验证码登录</div>

      <div class="login-wrapper">
        <!-- 微信扫码登录 -->
        <div class="wx-login" v-show="loginType==1">
          <div class="wx-text">请使用微信扫一扫</div>
          <div class="qrcode" id="loginQrcode"></div>
        </div>
        <!-- 账号登录 -->
        <div class="user-login" v-if="loginType==2">
          <div class="form-phone-con">
            <SelectInput
              type="number"
              @onInputChange="phoneChange"
              @onSelectChange="areaChange"
            />
          </div>
          <div class="form-phone-con" style="margin: 0px;">
            <SlotInput v-model="loginForm.password" :showPw="showPw" :rightWidth="16" placeholder="请输入密码" @onInputChange="passwordChange">
              <span class="password-suffix">
                <i
                  class="iconfont icon-style"
                  :class="elIcon"
                  autocomplete="auto"
                  @click="showPw = !showPw"
                />
              </span>
            </SlotInput>
          </div>
          <div class="forget-pass">
            <span style="cursor: pointer;" @click="goSetPass">忘记密码</span>
          </div>
          <a-button :disabled="!canSubmit" @click.native="handleLogin">立即登录</a-button>
        </div>
        <!-- 验证码登录 -->
        <div class="user-login" v-show="loginType==3">
          <div class="form-phone-con" v-if="loginType==3">
            <SelectInput
              type="number"
              @onInputChange="phoneChange"
              @onSelectChange="areaChange"
            />
          </div>
          <div class="form-phone-con" style="margin: 0px;" v-if="loginType==3">
            <SlotInput :maxlength="6" type="number" placeholder="输入验证码" @onInputChange="authCodeChange">
              <div
                class="code-btn"
                :disabled="!canGetCode || messageButton.disabled"
                :running="running"
                @click="onSendMessage"
              >
                {{ messageButton.text }}
              </div>
            </SlotInput>
          </div>
          <div class="forget-pass"></div>
          <a-button :disabled="!canSubmit" @click.native="handleLogin">立即登录</a-button>
        </div>

        <div class="link-txt">
          <span>同意</span>
          <a @click="openTab('https://app.saasz.vdyoo.com/slide/jyy-policy/agreement.html')">《用户协议》</a>
          <span>和</span>
          <a @click="openTab('https://app.saasz.vdyoo.com/slide/jyy-policy/policy.html')">《隐私政策》</a>
        </div>
      </div>
    </div>
    <ResetPw v-if="resetPw" @success="resetPwSuccess" @sendMessage="onSendMessage" />

    <div class="bottomEntry">
      <span v-if="loginType > 2 || resetPw"  @click="changeType()">返回登录</span>
      <span v-else @click="changeType(3)">验证码登录</span>
    </div>

    <el-dialog
      title=""
      custom-class="custom-slide-dialog"
      top="35vh"
      :show-close="true"
      :close-on-click-modal="false"
      :modal="false"
      :visible.sync="showSlide"
      width="330px">
      <div class="slide-box">
        <div class="str1">账户安全验证</div>
        <div class="str2">为了您的账户安全</div>
        <div class="str3">本次操作需要安全验证</div>
        <div id="slideContainerPc" class="slideContainer"></div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ResetPw from './components/ResetPw.vue'
import SelectInput from './components/SelectInput.vue'
import SlotInput from './components/SlotInput.vue'
import AButton from './components/Button.vue'
import { checkPhoneArea } from '@/js/utils/index.js'
import {sendMsgCode, loginByMsgCode} from '@/js/utils/login'
import { SCHOOL_Id, USER_INFO } from "@/js/utils/constant"
import TAL_UC from "@udc/tal-passport-jssdk"
import "@udc/tal-passport-jssdk/lib/qrcode.css"

export default {
  name: 'LoginBox',
  data() {
    return {
      activeTab: 1, // 1:扫码登录，2：账号登录
      loginType: 1, // 1:扫码登录，2：账号登录，3：验证码登录,
      resetPw: false, // 重设密码
      showPw: true,
      loginForm: {
        phone: "",
        selectArea: "86",
        authCode: "",
        password: "",
      },
      messageButton: {
        type: "",
        text: "发送验证码",
        disabled: false,
      },
      timer: null,
      running: false,
      showSlide: false,
      tag: "",
      newPassForm: {
        newPassword: "",
        secondPassword: "",
      },
    }
  },
  components: { ResetPw, SelectInput, SlotInput, AButton },
  computed: {
    type() {
      return this.showPw ? "text" : "password";
    },
    elIcon() {
      return this.showPw ? "icon-biyan" : "icon-yanjing1";
    },
    canSubmit() {
      if (this.loginType == 2) {
        return this.loginForm.phone && this.loginForm.password;
      } else if (this.loginType == 3 || this.resetPw) {
        return this.canGetCode && /^\d{6}$/.test(this.loginForm.authCode);
      } else {
        return this.canGetCode && this.loginForm.password;
      }
    },
    canGetCode() {
      return checkPhoneArea(this.loginForm.phone, this.loginForm.selectArea)
    }
  },
  watch: {
    loginType() {
      this.initState()
    }
  },
  methods: {
    initState() {
      this.running = false;
      clearInterval(this.timer);
      this.messageButton = {
        type: "",
        text: "发送验证码",
        disabled: false,
      };
      this.loginForm = {
        phone: "",
        selectArea: "86",
        authCode: "",
        password: "",
      }
    },
    validatePhone(value) {
      if (!value) {
        return "手机号不能为空";
      } else {
        if (this.canGetCode) {
          return "";
        } else {
          return "请输入正确的手机号";
        }
      }
    },
    validateAuthCode(value) {
      if (!value) {
        return "验证码不能为空";
      } else {
        const reg = /^\d{6}$/;
        if (reg.test(value)) {
          return "";
        } else {
          return "请输入6位数字手机验证码";
        }
      }
    },
    changeTab(tab) {
      this.activeTab = tab
      this.loginType = tab
      // if (this.loginType !== 1) {
      //   this.initWechatConfig()
      // }
    },
    changeType(type) {
      this.loginType = type || this.activeTab
      if (this.resetPw) {
        this.loginType = 2
        this.resetPw = false
        this.initState()
      }
    },
    phoneChange(value) {
      this.loginForm.phone = value;
    },
    passwordChange(value) {
      this.loginForm.password = value;
    },
    authCodeChange(value) {
      this.loginForm.authCode = value;
    },
    areaChange(value) {
      this.loginForm.selectArea = value;
    },
    openTab(url) {
      window.open(url)
    },
    handleLogin() {
      if (!this.canSubmit) return
      if (this.loginType == 3) {
        loginByMsgCode(this.loginForm.selectArea,this.loginForm.phone,this.loginForm.authCode,'slideContainerPc',this.handleLoginSuccess.bind(this),this.handleLoginFail.bind(this))
      }
      if (this.loginType == 2) {
        if (!this.canGetCode) {
          this.$message.error('请输入正确的手机号')
          return
        }
        const pwdparams = {
          data: {
            symbol: this.loginForm.selectArea + "-" + this.loginForm.phone, // 账号
            password: this.loginForm.password, // 密码
          },
          success: (res) => {
            if (res.errcode == 11033) {
              this.$message.error('输入账号有误')
              return;
            } else if (res.errcode == 11039) {
              this.$message.error('输入密码有误')
              return;
            } else if (res.errcode === 11021) {
              const param = {
                slideCallback: "loginPassword",
                slideParams: pwdparams,
                failCallback: function (error) {
                  alert(error.errmsg);
                },
              };
              this.showSlide = true;
              // 展示滑块
              TAL_UC.showSlide(param);
              return;
            } else if (res.errcode === 11033) {
              this.$message.warning(res.errmsg);
            } else if (res.errcode === 0) {
              // 登录成功
              this.showSlide = false;

              this.handleLoginSuccess(res);
            } else {
              this.$message.error(res.errmsg);
            }
          },
          fail: (error) => {
            this.$message.error("error=====", error);
          },
        };
        TAL_UC.loginPassword(pwdparams);
      }
    },
    handleLoginFail(res) {
   
    },
    handleLoginSuccess(res) {
      if (res.errcode!=0) {
        if (res.errcode === 11021) {
          this.showSlideBox()
          return
        }
        this.$message.error(res.errmsg)
        return
      }
      const { data = {} } = res;
      const { code } = data;
      this.$api.checkCode({code}).then((res)=>{
        const {data : userinfo} = res
        localStorage.setItem("token", userinfo.tal_token);
        localStorage.setItem("tal_id", userinfo.tal_id);
        this.$api.userDetail().then((userDetailRes) => {
          const {data: userinfodetail} = userDetailRes
          localStorage.setItem(SCHOOL_Id, userinfodetail.defaultOrg||1);
          localStorage.setItem(USER_INFO, JSON.stringify(userinfodetail))
          this.$store.commit('User/updateUserInfo',userinfodetail)
          this.$store.commit('User/updateSchoolId',userinfodetail.defaultOrg||1)
          this.$bus.$emit('changeLoginModal', false)
          this.$bus.$emit('loginSuccess', userinfodetail)
          TAL_UC.cancelQrcode()
        }).catch(err=>console.error(err))
      }).catch(error=>console.error(error))
    },
    goSetPass() {
      this.resetPw = true;
    },
    onSendMessage() {
      const sendSMSCodeLoginparams = {
        data: {
          verify_type: 1,
          phone_code: String(this.loginForm.selectArea),
          phone: String(this.loginForm.phone),
        },
        success: (res) => {
          if (res.errcode === 11021) {
            this.showSlideBox()
            return;
          }
          if (res.errcode === 0) {
            this.showSlide = false;
            if (this.messageButton.disabled) return;
            this.messageButton = {
              type: "primary",
              text: "60s后可重发",
              disabled: true,
            };
            let time = 60;
            this.running = true;
            this.timer = setInterval(() => {
              time -= 1;
              this.messageButton.text = `${time}s后获取`;
              if (time <= 0) {
                this.running = false;
                clearInterval(this.timer);
                this.messageButton = {
                  type: "primary",
                  text: "重新发送",
                  disabled: false,
                };
              }
            }, 1000);
          } else {
            console.log(res);
            this.$message.error(res.errmsg);
          }
        },
        fail: (error) => {
          console.log("error========", error);
          this.$message.info("获取验证码失败，请稍后重试！");
        },
      };
      TAL_UC.sendSMSCodeLogin(sendSMSCodeLoginparams);
    },
    onResetPwSendMessage(form) {
      this.loginForm = form
      this.onSendMessage()
    },
    showSlideBox() {
      this.showSlide = true
      const param = {
        slideCallback: "sendSMSCodeLogin",
        slideParams: {
          verify_type: 1,
          phone_code: String(this.loginForm.selectArea),
          phone: String(this.loginForm.phone),
        },
        failCallback: (error) => {
          alert(error.errmsg);
        },
      };
      TAL_UC.showSlide(param)
    },
    initWechatConfig() {
      let _this = this
      try {
        TAL_UC.cancelQrcode()
        TAL_UC.loginQrcode({
          renderToEle: "#loginQrcode",
          successCallback: function (res) {
            console.log("res---", res);
            // 扫码成功，获取登录code换取token
            var code = res.data.code;
            _this.handleLoginSuccess(res)
          },
          onExpired: (res) => {
            console.log(res, "wechat code expired");
          },
          onScanned: (res) => {
            const qrcodeTitle = document.querySelector('#loginQrcode #tal_heading-subtitle')
            const qrcodeTip = document.querySelector('#loginQrcode #tal_heading-subtitle-warn')
            if (qrcodeTitle) {
              qrcodeTitle.innerHTML = `<span style="font-size: 20px;color: #04cc4D;font-weight: 500;">扫码成功</span>`
            }
            if (qrcodeTip) {
              qrcodeTip.innerText = '请在手机端登录'
            }
          },
          onCancel: (res) => {
            console.log(res, "onCancel");
          },
          onQRCodeLoad: (res) => {
            console.log(res, "onQRCodeLoad");
          },
          failCallback: function (res) {
            console.log("res---", res);
          },
        });
      } catch (e) {
        console.log(e);
      }
    },
    resetPwSuccess() {
      this.initState()
      this.loginType = 2
      this.resetPw = false
    }
  },
  mounted() {
    TAL_UC.configNVC({
      renderToEle: `#slideContainerPc`,
      isH5: true,
    });
    this.initWechatConfig();
  },
  beforeDestroy() {
    clearInterval(this.timer);
  }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>

<style lang="scss">
#loginQrcode {
  #tal_qrcode {
    pointer-events: none;
  }
}

// 覆盖微信登录样式
.tal_tip-inner #tal_heading-subtitle {
  color: #04cc4D;
  font-size: 20px;
}
#tal_heading-subtitle-warn {
  color: #000 !important;
  font-size: 14px !important;
}
#tal_heading-icon-success {
  width: 44px !important;
  height: 44px !important;
  margin-bottom: 11px;
}
#tal_heading-icon-fail {
  width: 44px !important;
  height: 44px !important;
}
.tal_spinner .spinner-snake {
  border-color: #476eef #476eef transparent transparent !important;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/Login/LoginBox.vue